<script>
import { required } from "vuelidate/lib/validators";
import ApiType from "@/components/modals/api-type.vue";
export default {
    name: 'ApiModal',
    components: {
        ApiType
    },
    props: {
        targetName: {
            type: String,
            default: ''
        },
        modalTitle: {
            type: String,
            default: 'Create API'
        }
    },
    validations: {
        form: {
            name: { required },
        },
        apiType: { required },
    },
    data() {
        return {
            form: {
                id: 0,
                name: "",
                description: "",
                schedule: "",
                expectedOutput: "",
                planningTargetId: 0,
                isBigProject: false,
                apiTypeId: 0,
                addressingClimateChange: false,
                climateAddress: 'Adaptation'
            },
            apiType: '',
            climateAddreses: ['Adaptation', 'Mitigation'],
            submitted: false,
        };
    },
    methods: {
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;
            if(this.form.isBigProject){
                this.$v.apiType.$touch();
                if(this.$v.apiType.$invalid) return;
            }
            this.$emit('submit', this.form);
        },
        hideModal() {
            this.$bvModal.hide('api-modal');
        },
        changeIsBigProject(){
            this.apiType = "";
            this.form.apiTypeId = 0;
            this.form.apiType = null;
        },
        getApiType() {
            this.$bvModal.show("api-type-modal");
        },
        dropType(data) {
            this.apiType = data.type;
            this.form.apiTypeId = data.id;
        },
        onReset() {
            this.form = {
                id: 0,
                name: "",
                description: "",
                schedule: "",
                expectedOutput: "",
                apiTypeId: 0,
                planningTargetId: 0,
                isBigProject: false,
                addressingClimateChange: false,
                climateAddress: 'Adaptation'
            };
            this.apiType = "";
            this.$v.form.$reset();
            this.$v.apiType.$reset();
        },
        updateItem(props) {
            this.form = JSON.parse(JSON.stringify(props.item));
            this.form.dateCompleted = new Date(props.item.dateCompleted);
            this.form.climateAddress = props.item.isAdaptation ? 'Adaptation' : 'Mitigation';
            this.form.apiTypeId = props.item.apiTypeId ?? 0;
            this.apiType = props.item.apiType;
            this.$v.form.$reset();
            this.$v.previousWork.$reset();
        },
        getWork() {
            this.$refs.backlog.getData();
            this.$bvModal.show("backlog-modal");
        },
        dropWork(data) {
            this.previousWork = JSON.parse(JSON.stringify(data));
            this.form.apiId = data.id;
        },
    },
};
</script>
<template>
    <b-modal
        id="api-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form
            @submit.prevent="onCreate"
            class="needs-validation"
            ref="apiForm"
        >
            <p>Target: <span class="text-yellow">{{targetName}}</span></p>
            <b-row>
                <div class="mb-3">
                    <label for="name">Activity Program Initiative</label>
                    <textarea
                        id="name"
                        rows="5"
                        v-model="form.name"
                        placeholder="Enter Activity Program Initiative..."
                        class="form-control"
                        :class="{ 'is-invalid': submitted &&  $v.form.name.$error }"
                    ></textarea>
                    <div
                        v-if="submitted && $v.form.name.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.name.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="description">Expected Output
                    </label>
                    <textarea
                        autocomplete="off"
                        id="name"
                        rows="3"
                        v-model="form.expectedOutput"
                        placeholder="Enter Expected Output..."
                        class="form-control"
                    ></textarea>
                </div>
                <div class="mb-3">
                    <label for="description">Others Involved (Optional)
                    </label>
                    <textarea
                        autocomplete="off"
                        id="name"
                        rows="3"
                        v-model="form.description"
                        placeholder="Enter Others Involved..."
                        class="form-control"
                    ></textarea>
                </div>
                <div class="mb-3" v-if="$store.state.data.selectedCampus.isExternal">
                    <label for="description">Schedule
                    </label>
                    <textarea
                        autocomplete="off"
                        id="name"
                        rows="3"
                        v-model="form.schedule"
                        placeholder="Enter Schedule..."
                        class="form-control"
                    ></textarea>
                </div>
                <div class="mb-2">
                    <div class="form-check form-checkbox-outline form-check-success mb-0">
                        <input
                            type="checkbox"
                            id="isBigProject"
                            class="form-check-input"
                            v-model="form.isBigProject"
                            @change="changeIsBigProject"
                        />
                        <label  for="isBigProject" class="form-check-label">Special Project</label>
                    </div>
                </div>
                <div class="mb-3" v-if="form.isBigProject">
                    <label for="apiTypeId">API Type</label>
                    <b-input-group>
                        <template #append>
                            <b-button 
                                @click="getApiType"
                                variant="outline-info"
                            >
                                <i class="mdi mdi-clipboard-text-search-outline"></i>
                            </b-button>
                        </template>
                        <input
                            autocomplete="off"
                            type="text"
                            disabled
                            placeholder="Search API Type..."
                            class="form-control"
                            :class="{'is-invalid': submitted &&  $v.apiType.$error}"
                            v-model="apiType"
                        />
                    </b-input-group>
                    <div
                        v-if="submitted && $v.apiType.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.apiType.required">This value is required.</span>
                    </div>
                </div>
            </b-row>
            <div class="d-flex mb-2">
                <div class="form-check form-checkbox-outline form-check-success mb-0">
                    <input
                        type="checkbox"
                        id="addressClimateChange"
                        class="form-check-input"
                        v-model="form.addressingClimateChange"
                    />
                    <label  for="addressClimateChange" class="form-check-label">Addressing Climate Change</label>
                </div>
            </div>
            <div class="mb-2 ms-3" v-if="form.addressingClimateChange">
                <b-form-radio-group
                    v-model="form.climateAddress"
                    :options="climateAddreses"
                    name="status-options"
                    plain
                >
                </b-form-radio-group>
            </div>
            <div class="modal-footer">
                <button
                    type="submit"
                    class="btn btn-primary"
                >
                    Save changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="hideModal"
                >
                    Close
                </button>
            </div>
        </form>
        <api-type @dropData="dropType($event)"></api-type>
    </b-modal>
</template>